var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticStyle: { padding: "0 40px" } },
        [
          _c("span", { staticClass: "title-h4" }, [
            _vm._v(_vm._s(_vm.$t("voyagePlanSearch.title"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("voyagePlanSearch.polZH"),
                            prop: "pol",
                          },
                        },
                        [
                          _c("glPort", {
                            on: { change: _vm.polChange },
                            model: {
                              value: _vm.form.pol,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pol", $$v)
                              },
                              expression: "form.pol",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("voyagePlanSearch.podZH"),
                            prop: "pod",
                          },
                        },
                        [
                          _c("glPort", {
                            on: { change: _vm.podChange },
                            model: {
                              value: _vm.form.pod,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pod", $$v)
                              },
                              expression: "form.pod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("voyagePlanSearch.startDate"),
                            prop: "datefrom",
                          },
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c("el-date-picker", {
                                staticClass: "pickTime",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  clearable: "",
                                  placeholder: _vm.$t("placeholder.date"),
                                },
                                model: {
                                  value: _vm.form.datefrom,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "datefrom", $$v)
                                  },
                                  expression: "form.datefrom",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择时间范围" },
                                  model: {
                                    value: _vm.lastweeks,
                                    callback: function ($$v) {
                                      _vm.lastweeks = $$v
                                    },
                                    expression: "lastweeks",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "voyagePlanSearch.withinOneWeek"
                                      ),
                                      value: "1",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "voyagePlanSearch.withinTwoWeek"
                                      ),
                                      value: "2",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "voyagePlanSearch.withinThreeWeek"
                                      ),
                                      value: "3",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "voyagePlanSearch.withinFourWeek"
                                      ),
                                      value: "4",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-text": "ETA",
                                  "active-color": "#0086cb",
                                  "inactive-color": "#f03752",
                                  "inactive-text": "ETD",
                                },
                                on: { change: _vm.changeType },
                                model: {
                                  value: _vm.form.type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "type", $$v)
                                  },
                                  expression: "form.type",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.searchType,
                                        callback: function ($$v) {
                                          _vm.searchType = $$v
                                        },
                                        expression: "searchType",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("voyagePlanSearch.transfer")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 2 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          staticStyle: { "margin-top": "30px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.toSearch },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("btn.search")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", { staticClass: "warm-tips" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("voyagePlanSearch.tips_1"))
                ),
                _c("br"),
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("voyagePlanSearch.tips_2"))
                ),
                _c("br"),
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("voyagePlanSearch.tips_4"))
                ),
                _c("br"),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("voyagePlanSearch.tips_5")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.isResult && !_vm.validateNull(_vm.tableData)
      ? _c(
          "div",
          { staticClass: "result-container" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 14 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 2, offset: 21 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "warning",
                          disabled: !_vm.subscribeEnable,
                        },
                        on: { click: _vm.subscribe },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("voyagePlanSearch.subscribe")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, stripe: "", border: "" },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "serviceLineCode",
                    label: _vm.$t("voyagePlanSearch.lane"),
                    "min-width": "8%",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "vesselName",
                    label: _vm.$t("voyagePlanSearch.vessel"),
                    "min-width": "18%",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                staticStyle: { "font-size": "12px" },
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.skipVesselMovement(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.vesselName) +
                                    " " +
                                    _vm._s(scope.row.voyageNo) +
                                    _vm._s(scope.row.voyageLeg) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3521024655
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "polName",
                    label: _vm.$t("voyagePlanSearch.polEN"),
                    "min-width": "10%",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "polTerminalName",
                    label: _vm.$t("voyagePlanSearch.terminal"),
                    "min-width": "12%",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { prop: "etd", label: "ETD", "min-width": "10%" } },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "etd", label: "CTD", "min-width": "10%" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.etd) +
                                    " (" +
                                    _vm._s(
                                      _vm.weekFormatter(scope.row.weekEtd)
                                    ) +
                                    ")\n            "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", {
                                  staticStyle: {
                                    border: "0px",
                                    "border-bottom": "1px dashed",
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.validateNull(scope.row.ctd)
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat("MM-DD", scope.row.ctd)
                                        ) +
                                          " (" +
                                          _vm._s(
                                            _vm.weekFormatter(scope.row.ctd)
                                          ) +
                                          ")"
                                      ),
                                    ])
                                  : _c("div", [_vm._v(_vm._s(" "))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2412654041
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "podName",
                    label: _vm.$t("voyagePlanSearch.podEN"),
                    "min-width": "10%",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "podTerminalName",
                    label: _vm.$t("voyagePlanSearch.terminal"),
                    "min-width": "12%",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { prop: "eta", label: "ETA", "min-width": "10%" } },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "eta", label: "CTA", "min-width": "10%" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.eta) +
                                    " (" +
                                    _vm._s(
                                      _vm.weekFormatter(scope.row.weekEta)
                                    ) +
                                    ")\n            "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", {
                                  staticStyle: {
                                    border: "0px",
                                    "border-bottom": "1px dashed",
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.validateNull(scope.row.cta)
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat("MM-DD", scope.row.cta)
                                        ) +
                                          " (" +
                                          _vm._s(
                                            _vm.weekFormatter(scope.row.cta)
                                          ) +
                                          ")"
                                      ),
                                    ])
                                  : _c("div", [_vm._v(_vm._s(" "))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2126000412
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "underway",
                    label: _vm.$t("voyagePlanSearch.sailingTime"),
                    sortable: "",
                    "sort-method": function (a, b) {
                      return a.underway - b.underway
                    },
                    "min-width": "10%",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                !_vm.validateNull(scope.row.cta) &&
                                  !_vm.validateNull(scope.row.ctd)
                                  ? _vm.getTotalDaysByDateRange(
                                      scope.row.ctd,
                                      scope.row.cta
                                    )
                                  : scope.row.underway
                              ) +
                                " " +
                                _vm._s(_vm.$t("voyagePlanSearch.day"))
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1343405961
                  ),
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showTips
      ? _c("div", { staticClass: "result-container" }, [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "font-size": "14px" } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("voyagePlanSearch.resultTips_1"))),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#0086cb",
                    "text-decoration": "underline",
                    cursor: "pointer",
                  },
                  on: { click: _vm.toTsSearch },
                },
                [_vm._v(_vm._s(_vm.$t("voyagePlanSearch.resultTips_2")))]
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isTsResult
      ? _c(
          "div",
          { staticClass: "result-container" },
          _vm._l(_vm.tsTableData, function (item, index1) {
            return _c(
              "el-collapse",
              {
                model: {
                  value: _vm.activeNames,
                  callback: function ($$v) {
                    _vm.activeNames = $$v
                  },
                  expression: "activeNames",
                },
              },
              [
                _c(
                  "el-collapse-item",
                  {
                    staticStyle: { "margin-bottom": "4px" },
                    attrs: { name: index1 },
                  },
                  [
                    _c("template", { slot: "title" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "45%",
                            display: "flex",
                            "justify-content": "space-around",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "line-height": "24px",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v(_vm._s(item.portName.split("->")[0]))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "600",
                                    "font-size": "14px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.dateFormat(
                                          "YYYY-MM-DD",
                                          item.etdEta.split("->")[0]
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "30%",
                                "vertical-align": "center",
                                "text-align": "center",
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/cargoStatus/SHIP.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "underline" }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "line-height": "24px",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "font-size": "12px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.portName.split("->")[
                                        item.portName.split("->").length - 1
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "900",
                                    "font-size": "14px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.dateFormat(
                                          "YYYY-MM-DD",
                                          item.etdEta.split("->")[
                                            item.etdEta.split("->").length - 1
                                          ]
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { width: "25%", "line-height": "26px" },
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "900",
                                  "font-size": "15px",
                                },
                              },
                              [_vm._v(_vm._s(item.underway))]
                            ),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("voyagePlanSearch.day")) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { "font-size": "12px" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(item.portName.split("->").length - 2)
                              ),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("voyagePlanSearch.transshipment")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "120px",
                            "text-align": "right",
                            "margin-right": "10px",
                            color: "#409EFF",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.activeNames.includes(index1)
                                  ? _vm.$t("voyagePlanSearch.hideDetail")
                                  : _vm.$t("voyagePlanSearch.showDetail")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-timeline",
                          { staticStyle: { "margin-top": "20px" } },
                          _vm._l(
                            item.portName.split("->"),
                            function (it, index) {
                              return _c(
                                "el-timeline-item",
                                {
                                  attrs: {
                                    icon: "el-icon-location-outline",
                                    type: "primary",
                                    size: "large",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "600",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          index === 0 || index === 1
                                            ? item.etdEta.split("->")[index]
                                            : item.etdEta.split("->")[
                                                2 * index - 1
                                              ]
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "12px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          index === 0
                                            ? _vm.$t("voyagePlanSearch.etd1")
                                            : _vm.$t("voyagePlanSearch.etb1")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "900" } },
                                    [_vm._v(_vm._s(it))]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "12px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getPortTerminal(
                                            index,
                                            item.transType,
                                            item.terminalName
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "600",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          index === 0 ||
                                            index ===
                                              item.portName.split("->").length -
                                                1
                                            ? ""
                                            : item.etdEta.split("->")[2 * index]
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "12px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          index === 0 ||
                                            index ===
                                              item.portName.split("->").length -
                                                1
                                            ? ""
                                            : _vm.$t("voyagePlanSearch.etd1")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.validateNull(
                                    item.vesselVoyageLeg.split("->")[index]
                                  )
                                    ? _c(
                                        "el-card",
                                        {
                                          staticStyle: {
                                            "background-color": "#F5F7FA",
                                          },
                                          attrs: { shadow: "never" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "font-size": "12px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "30%",
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                        color: "#409EFF",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.handleVesselName(
                                                            item.vesselVoyageLeg.split(
                                                              "->"
                                                            )[index]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.vesselVoyageLeg.split(
                                                              "->"
                                                            )[index]
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getDiffDay(
                                                          index + 1 === 0 ||
                                                            index + 1 === 1
                                                            ? item.etdEta.split(
                                                                "->"
                                                              )[index + 1]
                                                            : item.etdEta.split(
                                                                "->"
                                                              )[
                                                                2 *
                                                                  (index + 1) -
                                                                  1
                                                              ],
                                                          index === 0
                                                            ? item.etdEta.split(
                                                                "->"
                                                              )[index]
                                                            : item.etdEta.split(
                                                                "->"
                                                              )[2 * index]
                                                        )
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "voyagePlanSearch.day"
                                                          )
                                                        ) +
                                                        "\n                  " +
                                                        _vm._s(
                                                          _vm.getDiffHour(
                                                            index + 1 === 0 ||
                                                              index + 1 === 1
                                                              ? item.etdEta.split(
                                                                  "->"
                                                                )[index + 1]
                                                              : item.etdEta.split(
                                                                  "->"
                                                                )[
                                                                  2 *
                                                                    (index +
                                                                      1) -
                                                                    1
                                                                ],
                                                            index === 0
                                                              ? item.etdEta.split(
                                                                  "->"
                                                                )[index]
                                                              : item.etdEta.split(
                                                                  "->"
                                                                )[2 * index]
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "voyagePlanSearch.hour"
                                                          )
                                                        )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "30%",
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "900",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.validateNull(
                                                              index -
                                                                +item.transType.charAt(
                                                                  0
                                                                ) <
                                                                0 ||
                                                                (+item.transType.charAt(
                                                                  2
                                                                ) > 0 &&
                                                                  index ===
                                                                    item.portName.split(
                                                                      "->"
                                                                    ).length -
                                                                      2)
                                                                ? ""
                                                                : item.serviceLineCode.split(
                                                                    "->"
                                                                  )[
                                                                    index -
                                                                      +item.transType.charAt(
                                                                        0
                                                                      )
                                                                  ]
                                                            )
                                                              ? ""
                                                              : _vm.$t(
                                                                  "voyagePlanSearch.lane"
                                                                )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          index -
                                                            +item.transType.charAt(
                                                              0
                                                            ) <
                                                            0 ||
                                                            (+item.transType.charAt(
                                                              2
                                                            ) > 0 &&
                                                              index ===
                                                                item.portName.split(
                                                                  "->"
                                                                ).length -
                                                                  2)
                                                            ? ""
                                                            : item.serviceLineCode.split(
                                                                "->"
                                                              )[
                                                                index -
                                                                  +item.transType.charAt(
                                                                    0
                                                                  )
                                                              ]
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            )
          }),
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showTsTips
      ? _c("div", { staticClass: "result-container" }, [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "font-size": "14px" } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("voyagePlanSearch.resultTips_3"))),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }